import styles from './SubcalcsContainer.module.css';

export const SubCalcsContainer = ({ children }) => {
  return <section className={styles.container}>
    {children}
  </section>
};
